export default __webpack_public_path__ + "static/media/im1.2c5309bd.jpg";